import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import { LegalPage } from "@/components/legal/LegalPage";

function DatenschutzPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header onCta={() => window.location.assign("/")} />
      <LegalPage
        title="Datenschutzerklärung"
        intro="1. Allgemeine Hinweise"
        sections={[
          {
            title: "1. Allgemeine Hinweise",
            paragraphs: [
              "Der Schutz Ihrer persönlichen Daten ist uns wichtig. Diese Datenschutzerklärung informiert Sie darüber, welche personenbezogenen Daten auf dieser Website erhoben und verarbeitet werden.",
            ],
          },
          {
            title: "2. Verantwortliche Stelle",
            paragraphs: ["Veritas Beratung GmbH", "E-Mail: kontakt@veritasberatung.com"],
          },
          {
            title: "3. Erhebung und Speicherung personenbezogener Daten",
            paragraphs: [
              "Beim Besuch dieser Website können automatisch Informationen allgemeiner Natur erfasst werden. Diese Informationen beinhalten beispielsweise Browsertyp, Betriebssystem, Domainnamen Ihres Internet-Service-Providers und ähnliche Daten.",
            ],
          },
          {
            title: "4. Kontaktformular",
            paragraphs: [
              "Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Formular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage gespeichert.",
            ],
          },
          {
            title: "5. Cookies",
            paragraphs: [
              "Unsere Website verwendet Cookies. Cookies dienen dazu, unser Angebot nutzerfreundlicher und effektiver zu machen.",
            ],
          },
          {
            title: "6. Google Analytics",
            paragraphs: [
              "Diese Website nutzt Google Analytics, einen Webanalysedienst von Google. Google Analytics verwendet Cookies, die eine Analyse der Benutzung der Website ermöglichen.",
            ],
          },
          {
            title: "7. Speicherung und Löschung von Daten",
            paragraphs: [
              "Personenbezogene Daten werden nur so lange gespeichert, wie dies zur Erfüllung der jeweiligen Zwecke erforderlich ist.",
            ],
          },
          {
            title: "8. Ihre Rechte",
            paragraphs: [
              "Sie haben jederzeit das Recht auf Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft, Empfänger sowie den Zweck der Datenverarbeitung.",
              "Außerdem haben Sie das Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.",
            ],
          },
          {
            title: "9. Kontakt",
            paragraphs: [
              "Bei Fragen zum Datenschutz können Sie uns jederzeit unter kontakt@veritasberatung.com kontaktieren.",
            ],
          },
        ]}
      />
      <Footer />
    </div>
  );
}

export const Route = createFileRoute("/datenschutz")({
  component: DatenschutzPage,
});